export const getRoot = state => state.get('author') || state;

export const getSelected = state => getRoot(state).get('selected');

export const isEditing = state => getRoot(state).get('isEditing');

export const isFetching = state => getRoot(state).get('isFetching');

export const getResults = state => getRoot(state).get('results');

export const getMessage = state => getRoot(state).get('message');
